import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import trash from '../../../../assets/img/svg/table/trash.svg';
import GeoFilters from './GeoFilters';
import { t } from 'i18next';

import { useAllFilters } from '../../../../hook/useAllFilters';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { Visibility } from '../../../../enum/Visibility';
import { useFilterDropdown } from '../../../../hook/useFilterDropdown';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { closeFilterDropdown } from '../../../../store/slice/filter-slice';

interface CashRegisterFiltersSetupProps {
  setShowFilters: Dispatch<SetStateAction<boolean>>;
}

const CashRegisterFiltersSetup: React.FC<CashRegisterFiltersSetupProps> = ({ setShowFilters }) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.globalFilters);

  const { handleApplyAllFilters } = useAllFilters();

  const {
    openDropdown,
    justClosed,
    toggleDropdown,
    updateFilters,
    setOpenDropdown,
    setJustClosed,
    handleResetFilters,
    isOpen,
  } = useFilterDropdown();

  const [justReset, setJustReset] = useState(false);
  const [show, setShow] = useState(!filters.Group?.length);
  const openFilterDropDown = useAppSelector((state) => state.filters.openFilterDropDown);

  function handleResetAndApply() {
    handleResetFilters();
    //  We cannot call handleApplyAllFilters immediately after reset,
    //  because Redux state updates are async.
    // /This flag ensures apply is triggered only after reset is completed.
    setJustReset(true);
    setShowFilters(true);
    setShow(true);
    dispatch(closeFilterDropdown());
  }

  useEffect(() => {
    if (justReset) {
      // At this point filters are already reset in Redux,
      // so applying filters will use the correct (empty) state
      handleApplyAllFilters();
      setJustReset(false);
    }
  }, [justReset, handleApplyAllFilters]);

  useEffect(() => {
    if (!show || !openFilterDropDown) {
      setOpenDropdown(null);
      setJustClosed(null);
    }
  }, [show, openFilterDropDown, setJustClosed, setOpenDropdown]);

  useEffect(() => {
    if (filters.Region && filters.Group?.length === 0) {
      setShow(true);
      setShowFilters(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.Group?.length]);

  return (
    <div
      className={`filter_setup cash_register_filter_setup ${show || openFilterDropDown ? Visibility.VISIBLE : Visibility.HIDDEN} ${
        show && openDropdown ? 'expanded' : 'not_expanded'
      }`}
    >
      <div className="filter_header">
        <span className="title cash_register_title">{t('cashRegister.filters.header.selectAGroup')}</span>
      </div>
      <div className="filter_controls">
        <GeoFilters
          toggleDropdown={toggleDropdown}
          isOpen={isOpen}
          filters={filters}
          setFilters={updateFilters}
          justClosed={justClosed}
        />
        <div className="reset_all" onClick={handleResetAndApply}>
          <img src={trash} alt="Reset all" />
          <span>{t('statisticPage.header.filter.resetAll')}</span>
        </div>
        <button
          disabled={!filters.Group || filters.Group.length === 0}
          className="apply_filters"
          onClick={() => {
            handleApplyAllFilters();
            dispatch(closeFilterDropdown());
            setShow(false);
            setShowFilters(false);
          }}
        >
          {t('statisticPage.header.filter.applyFilters')}
        </button>
      </div>
    </div>
  );
};

export default CashRegisterFiltersSetup;
